import {Injectable} from '@angular/core';
import {CasaNativeApiV3} from "../casa-native-api";
import {Observable} from "rxjs";
import {PublicV3RestService} from "../v3/public-rest.service";
import {
  CountryDefinition,
  V3Address,
  V3ContactEntry,
  V3ContactEntryDetails,
  V3Person,
  V3PersonalSensitiveDetails,
  V3PersonDetails,
  V3Settings,
} from "../../../model/v3/people";
import {HttpEvent} from '@angular/common/http';
import {V3FileItem} from 'src/app/auth_profile/model/v3/file';
import {SchoolStudentStatus, V3School, V3SchoolTeacher, V3Student, V3Teacher,} from 'src/app/auth_profile/model/v3/schools';
import {Page, Pageable} from 'src/app/utils/pageable';

@Injectable({
  providedIn: 'root'
})
export class CasaEmulatedService implements CasaNativeApiV3 {

  constructor(
    private publicV3Rest: PublicV3RestService,
  ) {
  }

  findTeachers(schoolId: number, term?: string | null, productCode?: string | null, pageable?: Pageable | null): Observable<Page<V3Teacher>> {
    throw new Error("Method not implemented.");
  }

  getTeachers(
    schoolId?: number | null,
    personId?: number | null,
    email?: string | null,
    teacherIds?: number[] | null,
    pageable?: Pageable | null
  ): Observable<Page<V3SchoolTeacher>> {
    throw new Error('Method not implemented.');
  }

  uploadFile(file: File): Observable<HttpEvent<any>> {
    throw new Error('Method not implemented.');
  }

  getPerson(personId: number): Observable<V3Person> {
    throw new Error('Method not implemented.');
  }

  updatePerson(personId: number, details: V3PersonDetails): Observable<V3Person> {
    throw new Error('Method not implemented.');
  }

  deletePerson(personId: number): Observable<void> {
    throw new Error('Method not implemented.');
  }

  listContacts(personId: number): Observable<V3ContactEntry[]> {
    throw new Error('Method not implemented.');
  }

  createContact(personId: number, contact: V3ContactEntryDetails): Observable<void> {
    throw new Error('Method not implemented.');
  }

  updateContact(personId: number, contactId: number, contact: V3ContactEntryDetails): Observable<void> {
    throw new Error('Method not implemented.');
  }

  getAddress(personId: number): Observable<V3Address> {
    throw new Error('Method not implemented.');
  }

  updateAddress(personId: number, address: V3Address): Observable<void> {
    throw new Error('Method not implemented.');
  }

  getSensitive(personId: number): Observable<V3PersonalSensitiveDetails> {
    throw new Error('Method not implemented.');
  }

  updateSensitive(personId: number, sensitive: V3PersonalSensitiveDetails): Observable<void> {
    throw new Error('Method not implemented.');
  }

  getPhoto(personId: number): Observable<V3FileItem> {
    throw new Error('Method not implemented.');
  }

  updatePhoto(personId: number, file: V3FileItem): Observable<void> {
    throw new Error('Method not implemented.');
  }

  getSettings(personId: number): Observable<V3Settings> {
    throw new Error('Method not implemented.');
  }

  updateSettings(personId: number, settings: V3Settings): Observable<void> {
    throw new Error('Method not implemented.');
  }

  listCountries(): Observable<CountryDefinition[]> {
    return this.publicV3Rest.listCountries();
  }

  getSchool(schoolId: number): Observable<V3School> {
    throw new Error('Method not implemented.');
  }

  getStudents(
    schoolId: number,
    term?: string | null,
    status?: SchoolStudentStatus[] | null,
    expiry?: Date | string | null,
    pageable?: Pageable,
  ): Observable<Page<V3Student>> {
    throw new Error('Method not implemented.');
  }

  getStudent(schoolId: number, studentId: number): Observable<V3Student> {
    throw new Error('Method not implemented.');
  }

  getTeacher(schoolId: number, teacherId: number): Observable<V3Teacher> {
    throw new Error('Method not implemented.');
  }

  isImplemented(): boolean {
    return true;
  }

  supportsFileSending(): boolean {
    return false;
  }

  isSupportsProfileEdit(): Boolean {
    return false;
  }
}
